module.exports = __webpack_public_path__ + "55e7e54b47fa18d76edbc43339f40919.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/columbia_university_2023_chart.png
// module id = 1657
// module chunks = 0